export const LessonNoteModule = {
    namespaced: true,

    state: {
        editing_note_id: null,
        creating_note_module_id: null,
        creating_note_course_id: null,
        creating_note_lesson_id: null,
        search: ""
    },
    actions: {
        startCreatingNote({commit}, payload) {
            commit('START_CREATING', payload)
        },
        cancelCreatingNote({commit}) {
            commit('CANCEL_CREATING')
        },

    },

    mutations: {
        START_CREATING(state, payload) {
            state.creating_note_module_id = payload.module_id
            state.creating_note_course_id = payload.course_id
            state.creating_note_lesson_id = payload.lesson_id
        }, CANCEL_CREATING(state) {
            state.creating_note_module_id = null
            state.creating_note_course_id = null
            state.creating_note_lesson_id = null
        },
    }
};
